import {mount} from 'svelte';

import * as Utils from '@js/modules/utils';
import {videoLazyLoader} from '@js/modules/videoLazyLoader';
import AnimateElement from '@js/modules/animateElement';
import Testimonials from '@js/modules/testimonials';

import PlannerSearch from '@js/components/planner/PlannerSearch.svelte';

const PlannerMap = () => import('@js/components/planner/PlannerMap.svelte');
const PlannerComputation = () => import('@js/components/planner/PlannerComputation.svelte');

const TimeToStartButton = () => import('@js/components/maps/timeToStart/TimeToStartButton.svelte');

const RideCreation = () => import('@js/components/ride/RideCreation.svelte');


class PlannerManager {
    _$rideType = document.getElementById('ride-type');

    _model = {
        rideType: null,
        mapId: 'planner-map'
    };

    _components = {
        $searchForm: document.getElementById('planner-search'),
        $map: document.getElementById('planner-map-container'),
        $computation: document.getElementById('planner-computation'),
        $timeToStart: document.getElementById('planner-time-to-start'),
        $rideCreation: document.getElementById('planner-ride-creation')
    };

    /* Public methods
    ******************** */
    constructor() {
        this._model.rideType = this._$rideType.innerText;
    }

    initialize = () => {
        this._mountComponents();

        this._mountAsyncComponents();

        AnimateElement.initialize();

        videoLazyLoader();

        Testimonials.initialize();
    };

    /* Private methods
    ******************** */
    _mountComponents = () => {
        mount(PlannerSearch, {
            target: this._components.$searchForm,
            props: {
                rideType: this._model.rideType,
                mapId: this._model.mapId
            }
        });
    };

    _mountAsyncComponents = () => {
        Utils.onPageReady(() => {
            PlannerMap()
                .then(({default: PlannerMapComponent}) => {
                    mount(PlannerMapComponent, {
                        target: this._components.$map,
                        props: {
                            rideType: this._model.rideType,
                            mapId: this._model.mapId
                        }
                    });

                    // Class used for preserving space on initial load
                    this._components.$map.classList.remove('planner-map-container-preload');
                });

            setTimeout(() => {
                PlannerComputation()
                    .then(({default: PlannerComputationComponent}) => {
                        mount(PlannerComputationComponent, {
                            target: this._components.$computation,
                            props: {}
                        });
                    });

                TimeToStartButton()
                    .then(({default: TimeToStartButtonComponent}) => {
                        mount(TimeToStartButtonComponent, {
                            target: this._components.$timeToStart,
                            props: {}
                        });
                    });
            }, 800);

            setTimeout(() => {
                RideCreation()
                    .then(({default: RideCreationComponent}) => {
                        mount(RideCreationComponent, {
                            target: this._components.$rideCreation,
                            props: {
                                defaultRideVisibility: 'only_me',
                                defaultPlanned: true
                            }
                        });
                    });
            }, 2500);
        });
    };
}

export default new PlannerManager();
